import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class BondCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Bond Cleaning Gold Coast | End of Lease Cleaning Experts"
          description="Bond cleaning Gold Coast specialists. Detailed end of lease cleaning services to help secure your full bond return."
          keywords="bond cleaning gold coast, end of lease cleaning gold coast, vacate cleaning gold coast, exit cleaning gold coast, move out cleaning gold coast, end of tenancy cleaning gold coast, rental cleaning gold coast, inspection cleaning gold coast, relocation cleaning gold coast, professional bond cleaners gold coast, real estate cleaning gold coast, carpet steam cleaning gold coast, window cleaning gold coast, tile and grout cleaning gold coast, oven cleaning gold coast, full house bond cleaning gold coast, apartment bond cleaning gold coast, unit bond cleaning gold coast, last minute bond cleaning gold coast, urgent bond cleaning gold coast, affordable bond cleaning gold coast, reliable bond cleaners gold coast, same day bond cleaning gold coast, professional exit cleaning gold coast, vacate carpet cleaning gold coast, bond back cleaning service gold coast, rental property cleaning gold coast, property handover cleaning gold coast, deep vacate cleaning gold coast, move out house cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Bond Cleaning Gold Coast</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            Professional End of Lease Cleaning Gold Coast
                          </h4>
                          <p>
                            Moving out of a rental property can be stressful.
                            Our bond cleaning Gold Coast service ensures your
                            property is thoroughly cleaned and inspection ready.
                            We follow strict real estate agency cleaning
                            standards and comprehensive checklists.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            What Is Included in Our Bond Cleaning Service
                          </h4>
                          <p>Our end of lease cleaning Gold Coast includes:</p>
                          <ul className="list-check primary">
                            <li>Kitchen deep cleaning</li>
                            <li>Oven cleaning</li>
                            <li>Bathroom sanitisation</li>
                            <li>Window cleaning</li>
                            <li>Wall spot cleaning</li>
                            <li>Floor mopping and vacuuming</li>
                            <li>Carpet steam cleaning (optional add-on)</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Vacate Cleaning Gold Coast for All Property Types
                          </h4>
                          <p>We provide vacate cleaning services for:</p>
                          <ul className="list-check primary">
                            <li>Apartments in Surfers Paradise</li>
                            <li>Houses in Burleigh Heads</li>
                            <li>Units in Broadbeach</li>
                            <li>Townhouses across Gold Coast</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Our Bond Cleaners
                          </h4>
                          <ul className="list-check primary">
                            <li>Detailed checklist-based cleaning</li>
                            <li>Experienced professional cleaners</li>
                            <li>Flexible scheduling</li>
                            <li>Fast turnaround time</li>
                            <li>Affordable pricing</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Service Areas</h4>
                          <ul className="list-check primary">
                            <li>Gold Coast</li>
                            <li>Southport</li>
                            <li>Broadbeach</li>
                            <li>Surfers Paradise</li>
                            <li>Burleigh Heads</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default BondCleaningGoldCoast;
